/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ResourcePoolProviderType = 'GCVE' | 'VMCA' | 'EVS';

export const ResourcePoolProviderType = {

    GCVE: 'GCVE' as ResourcePoolProviderType,

    VMCA: 'VMCA' as ResourcePoolProviderType,

    EVS: 'EVS' as ResourcePoolProviderType
};

